import React, { Component } from "react";
import Spinner from "../../Common/Spinner";
import { getProperty } from "../../../CommonFunctions";

class NewAuditTrail extends Component {
  styles = {
    container: {
      maxWidth: "64rem",
      padding: "24px 0",
      backgroundColor: "#ffffff",
    },

    spaceWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },

    row: {
      display: "flex",
    },

    dateSection: {
      width: "200px",
      flexShrink: 0,
      marginRight: "8px",
      textAlign: "right",
      paddingRight: "8px",
      wordBreak: "break-word",
      color: "var(--list-item-gray)",
      fontSize: "14px",
    },

    timelineWrapper: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "24px",
      flexShrink: 0,
    },

    timelineLine: {
      position: "absolute",
      top: "4px",
      bottom: 0,
      width: "1px",
      backgroundColor: "#d1d5db",
    },

    dot: {
      width: "12px",
      height: "12px",
      borderRadius: "50%",
      zIndex: 10,
      marginTop: "4px",
      flexShrink: 0,
    },

    contentWrapper: {
      flex: 1,
      minWidth: 0,
      paddingBottom: "8px",
      marginLeft: "8px",
    },

    contentInner: {
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
    },

    actionRow: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flexWrap: "wrap",
    },

    actionText: {
      fontWeight: 500,
      wordBreak: "break-word",
    },

    grayText: {
      color: "var(--list-item-gray)",
    },

    userText: {
      fontWeight: 500,
      wordBreak: "break-word",
    },

    card: {
      backgroundColor: "#f9fafb",
      padding: "12px",
      borderRadius: "8px",
      border: "1px solid #f3f4f6",
      marginTop: "8px",
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "8px",
      fontSize: "14px",
    },

    emailRow: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      columnGap: "8px",
    },

    emailText: {
      color: "#000000",
      wordBreak: "break-all",
    },

    noData: {
      textAlign: "center",
      color: "var(--list-item-gray)",
    },
  };

 

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      console.log("AuditTrail data:", this.props.data);
    }
  }

  formatUTCDate = (isoString) => {
    const date = new Date(isoString);

    if (isNaN(date.getTime())) return "Invalid date";

    const formattedDate =
      date.getUTCFullYear() +
      "-" +
      String(date.getUTCMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getUTCDate()).padStart(2, "0");

    const formattedTime =
      String(date.getUTCHours()).padStart(2, "0") +
      ":" +
      String(date.getUTCMinutes()).padStart(2, "0") +
      ":" +
      String(date.getUTCSeconds()).padStart(2, "0");

    return `${formattedDate} ${formattedTime}`;
  };

  formatLocalDate = (isoString) => {
    const date = new Date(isoString);

    if (isNaN(date.getTime())) return "Invalid date";

    const formattedDate =
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0");

    const formattedTime =
      String(date.getHours()).padStart(2, "0") +
      ":" +
      String(date.getMinutes()).padStart(2, "0") +
      ":" +
      String(date.getSeconds()).padStart(2, "0");

    return `${formattedDate} ${formattedTime}`;
  };

  formatDate = (timestamp) => {
    if (!timestamp) return "Unknown date";

    if (
      typeof timestamp === "string" ||
      timestamp instanceof Date
    ) {
      return this.formatUTCDate(timestamp);
    }

    if (typeof timestamp === "number") {
      return this.formatLocalDate(
        new Date(timestamp).toISOString()
      );
    }

    return "Unknown date format";
  };

  getActionColor = (action) => {
    const actionValue = action
      ? action.toUpperCase()
      : "";

    switch (actionValue) {
      case "EDIT":
        return {
          bg: "#3b82f6",
          text: "#2563eb",
          icon: "edit",
        };

      case "AUTO EDIT":
        return {
          bg: "#a855f7",
          text: "#9333ea",
          icon: "automatic",
        };

      case "LOGIN":
        return {
          bg: "#22c55e",
          text: "#16a34a",
          icon: "login",
        };

      case "LOGOUT":
        return {
          bg: "#ef4444",
          text: "#dc2626",
          icon: "logout",
        };

      case "CREATE":
        return {
          bg: "#14b8a6",
          text: "#0d9488",
          icon: "add",
        };

      case "DELETE":
        return {
          bg: "#f43f5e",
          text: "#e11d48",
          icon: "delete",
        };

      default:
        return {
          bg: "#6b7280",
          text: "#4b5563",
          icon: "default",
        };
    }
  };

   defaultFields = [
    // { key: "Action", label: "Action" },
    // { key: "ActionBy", label: "Action By" },
    { key: "ActionByEmailID", label: "Email" }
  ];
  render() {
    const { 
      data, 
      loading, 
      fields, 
      leftFields,  // New prop for left side fields
      showTimeline = true 
    } = this.props;
    const styles = this.styles;

    const displayFields = fields || this.defaultFields;
    const leftSideFields = leftFields || [{ key: "ActionOn", label: "",type:"date" }];

    return (
      <div style={styles.container}>
        {loading ? (
          <Spinner hideOverlay={true} />
        ) : data && data.length > 0 ? (
          <div style={styles.spaceWrapper}>
            {data.map((item, index) => {
              const action = getProperty(item, "Action");
              const actionBy = getProperty(item, "ActionBy");

              const { bg, text } = this.getActionColor(action);

              return (
                <div key={getProperty(item, "_id") || index} style={styles.row}>
                  {/* Left side - Custom fields */}
                  <div style={styles.dateSection}>
                    {leftSideFields.map((field) => (
                      <div key={field.key} style={{ marginBottom: '4px' }}>
                        <div style={{ fontSize: '12px', color: 'var(--list-item-gray)' }}>
                          {field.label}
                        </div>
                      <div style={{ fontWeight: '500' }}>
  {field.type === "date"
    ? this.formatDate(getProperty(item, field.key))
    : (getProperty(item, field.key) || "N/A")}
</div>
                      </div>
                    ))}
                  </div>

                  {/* Timeline */}
                  {showTimeline && (
                    <div style={styles.timelineWrapper}>
                      <div style={styles.timelineLine}></div>
                      <div style={{ ...styles.dot, backgroundColor: fields 
        ? (index % 2 === 0 ? "#6b7280" : "#3b82f6")
        : bg  }}></div>
                    </div>
                  )}

                  {/* Audit content */}
                  <div style={styles.contentWrapper}>
                   {!fields && <div style={styles.contentInner}>
                      <div style={styles.actionRow}>
                        <span style={{ ...styles.actionText, color: text }}>
                          {action}
                        </span>
                        <span style={styles.grayText}>by</span>
                        <span style={styles.userText}>{actionBy}</span>
                      </div>
                    </div>}

                    <div style={styles.card}>
                      <div style={styles.grid}>
                        {displayFields.map((field) => (
                          <div key={field.key} style={styles.emailRow}>
                            <span style={styles.grayText}>
                              {field.label}:
                            </span>
                            <span style={styles.emailText}>
                              {getProperty(item, field.key) || "N/A"}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={styles.noData}>No audit data available</div>
        )}
      </div>
    );
  }
}


export default NewAuditTrail;